import { render, staticRenderFns } from "./ContactDistributionsByTag.vue?vue&type=template&id=352727ea&scoped=true"
import script from "./ContactDistributionsByTag.vue?vue&type=script&lang=js"
export * from "./ContactDistributionsByTag.vue?vue&type=script&lang=js"
import style0 from "./ContactDistributionsByTag.vue?vue&type=style&index=0&id=352727ea&prod&lang=scss"
import style1 from "./ContactDistributionsByTag.vue?vue&type=style&index=1&id=352727ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352727ea",
  null
  
)

export default component.exports